import script from "./Panel.vue?vue&type=script&setup=true&lang=js"
export * from "./Panel.vue?vue&type=script&setup=true&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=2b4d1136&lang=css"

const __exports__ = script;

export default __exports__